import { produce } from 'immer';
import * as Types from 'js/hooks/useGetJackpots/types';
import { reducer as baseReducer } from '@core/js/hooks/useGetJackpots/store/reducer';
import { IJackpotState, ISetSkywindAndGreentubeJackpotsAction, actionTypes } from './types';
import { JACKPOT_KEYS, JACKPOTS_TYPES } from './constants';
import { extendReducerWithSwitch } from '@theme/js/utils/extendReducer/extendReducerWithSwitchCase';

const getKeyByType = (type?: JACKPOTS_TYPES) => type ? JACKPOT_KEYS[type] : JACKPOTS_TYPES.JACKPOTS;

export const defaultState: IJackpotState = {
    jackpotStartTime: null,
    [JACKPOTS_TYPES.JACKPOTS]: <Types.TJackpots>{},
    [JACKPOTS_TYPES.GREEN_TUBE_JACKPOTS]: <Types.TJackpots>{},
    [JACKPOTS_TYPES.SKY_WIND_JACKPOT]: <Types.TJackpots>{}
};

export const newReducer = produce((draftState, action: ISetSkywindAndGreentubeJackpotsAction): IJackpotState | void => {
    switch (action.type) {
        case actionTypes.SET_SKYWIND_AND_GREENTUBE: {
            const { jackpotType } = action.payload;
            const k = getKeyByType(jackpotType);

            draftState[k] = {
                ...draftState[k],
                ...action.payload[k]
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }

        default:
            break;
    }
}, defaultState);

export const reducer = extendReducerWithSwitch(baseReducer, newReducer as any);
